export default __webpack_public_path__ + "//i/components/system-notification/images//user-deleted-img.png";